import {
  COVERAGE_AREA_DIALOG_MESSAGES,
  CoverageAreaDialogMessages,
} from "./coverage-area-dialog.messages";
import {
  COVERAGE_AREA_FILTERS_MESSAGES,
  CoverageAreaFiltersMessages,
} from "./coverage-area-filters.messages";
import {
  COVERAGE_AREA_FORM_MESSAGES,
  CoverageAreaFormMessages,
} from "./coverage-area-form.messages";
import {
  COVERAGE_AREA_REQUEST_MESSAGES,
  CoverageAreaRequestMessages,
} from "./coverage-area-request.messages";
import {
  COVERAGE_AREA_TABLE_MESSAGES,
  CoverageAreaTableMessages,
} from "./coverage-area-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type CoverageAreaMessages = ActionButtonMessages &
  SidebarMessages &
  PopoverMessages &
  CoverageAreaFormMessages &
  CoverageAreaFiltersMessages &
  CoverageAreaRequestMessages &
  CoverageAreaTableMessages &
  CoverageAreaDialogMessages & {
    // Titles
    pageTitle: string;
    breadCrumbTitle: string;
    createPageTitle: string;
    createCoverageAreaBreadCrumbTitle: string;
    updatePageTitle: string;
    updateCoverageAreaBreadCrumbTitle: string;
    coverageAreaTableTitle: string;

    // Button Messages
    addCoverageAreaButton: string;
    importCoverageAreasButton: string;
  };

export const COVERAGE_AREA_MESSAGES: CoverageAreaMessages = {
  // Titles
  pageTitle: "Áreas de abrangência",
  createPageTitle: "Criar Área de Abrangência",
  updatePageTitle: "Editar Área de Abrangência",
  coverageAreaTableTitle: "Listagem de Áreas de Abrangência",

  breadCrumbTitle: "Área de Abrangência",
  createCoverageAreaBreadCrumbTitle: "Criar Área de Abrangência",
  updateCoverageAreaBreadCrumbTitle: "Editar Área de Abrangência",

  // Button Messages
  addCoverageAreaButton: "Nova Área",
  importCoverageAreasButton: "Carregar Regiões",

  ...COVERAGE_AREA_DIALOG_MESSAGES,
  ...COVERAGE_AREA_TABLE_MESSAGES,
  ...COVERAGE_AREA_REQUEST_MESSAGES,
  ...COVERAGE_AREA_FORM_MESSAGES,
  ...COVERAGE_AREA_FILTERS_MESSAGES,

  ...POPOVER_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};

// no default export
